import { ReactElement } from "react";

import styles from "./index.module.css";
import { blur, isTouchScreen } from "../../../lib/dom";
import { IconName } from ".";

export default function IconButton(props: {
  name: IconName;
  disabled?: boolean;
  highlighted?: boolean;
  onClick: () => void;
  tooltip?: string;
}): ReactElement {
  return (
    <>
      <button
        className={`${styles.icon} ${
          props.highlighted ? styles.highlighted : ""
        }`}
        disabled={props.disabled}
        onClick={({ target }) => {
          blur(target);
          props.onClick();
        }}
        data-tip={isTouchScreen ? undefined : props.tooltip}
      >
        <img src={require(`./imgs/${props.name}.webp`)} alt={props.name} />
      </button>
    </>
  );
}
